export const bidConstants={
    list:{
        fields:{
            id:"ID",
            title:"BidTitle",
            brief:"BidBrief",
            description:"BidDescription",
            expirationDate:"BidExpirationDate",
            modificationDate:"Modified",
            file:"FileRef"
        }
    }
    ,
    camlQuery:{
        BidList:`
    <View>  
        <Query> 
            <Where>
                <Geq>
                    <FieldRef Name='BidExpirationDate' /><Value Type='DateTime'><Today /></Value>
                </Geq>
            </Where>
            <OrderBy>
                <FieldRef Name='Modified' Ascending='FALSE' />
            </OrderBy> 
        </Query> 
        <ViewFields>
            <FieldRef Name='ID' />
            <FieldRef Name='BidTitle' />
            <FieldRef Name='BidBrief' />
            <FieldRef Name='BidDescription' />
            <FieldRef Name='BidExpirationDate' />
            <FieldRef Name='Modified' />
            <FieldRef Name='FileRef' />
        </ViewFields> 
        <RowLimit>{{numberPageSize}}</RowLimit> 
    </View>`,
    AllBidList:`
    <View>  
        <Query> 
            <Where>
                <Geq>
                    <FieldRef Name='BidExpirationDate' /><Value Type='DateTime'><Today /></Value>
                </Geq>
            </Where>
            <OrderBy>
                <FieldRef Name='Modified' Ascending='FALSE' />
            </OrderBy> 
        </Query> 
        <ViewFields>
            <FieldRef Name='ID' />
            <FieldRef Name='BidTitle' />
            <FieldRef Name='BidBrief' />
            <FieldRef Name='BidDescription' />
            <FieldRef Name='BidExpirationDate' />
            <FieldRef Name='Modified' />
            <FieldRef Name='FileRef' />
        </ViewFields>
    </View>`
},
    slash : "/"
}